const initialState = {
	is3DotMenu: false,
	isDropDownMenu: false,
	isProfileMenu: false,
	isPagesMenu: false,
	isMailMenu: false,
	isNotificationMenu: false,
	isLanguageMenu: false,
	isAuthMenu: false,
	isToggleLeftBar: false,
	isToggleRightBar: false,
	isOpenSettingBar: false,
	themeColor: 'cyan',
	isDarkMode: false,
	isDarkHeader: false,
	isFixNavbar: false,
	isMinSidebar: false,
	isDarkSidebar: false,
	isIconColor: false,
	isGradientColor: true,
	isBoxShadow: false,
	isBoxLayout: false,
	isRtl: false,
	isMenuGrid: false,
	isFont: "font-muli",
	// isSubMenuIcon: "list-a",
	// isMenuIcon: "list-c"
}

export default (state = initialState, action) => {
	switch (action.type) {
		case 'TOGGLE_LEFT_SIDEBAR':
			return {
				...state,
				isToggleLeftBar: action.payload
			}
		case 'TOGGLE_RIGHT_SIDEBAR':
			return {
				...state,
				isToggleRightBar: action.payload
			}
		case 'TOGGLE_SETTING_BAR':
			return {
				...state,
				isOpenSettingBar: action.payload
			}
		case 'THEME_COLOR_CHANGE':
			return {
				...state,
				themeColor: action.payload
			}
		case 'CHANGE_ICON_COLOR':
			return {
				...state,
				isIconColor: action.payload
			}
		case 'CHANGE_GRADIENT_COLOR':
			return {
				...state,
				isGradientColor: action.payload
			}
		case 'CHANGE_BOX_SHADOW':
			return {
				...state,
				isBoxShadow: action.payload
			}
		case 'CHANGE_BOX_LAYOUT':
			return {
				...state,
				isBoxLayout: action.payload
			}
		case 'CHANGE_FONT':
			return {
				...state,
				isFont: action.payload
			}
		case 'TOGGLE_AUTH_MENU':
			return {
				...state,
				isAuthMenu: action.payload
			}
		case 'TOGGLE_LANGUAGE_MENU':
			return {
				...state,
				isLanguageMenu: action.payload
			}
		case 'TOGGLE_PROFILE_MENU':
			return {
				...state,
				isProfileMenu: action.payload
			}
		case 'TOGGLE_PAGE_MENU':
			return {
				...state,
				isPagesMenu: action.payload
			}
		case 'TOGGLE_3DOT_MENU':
			return {
				...state,
				is3DotMenu: action.payload
			}
		case 'TOGGLE_DROPDOWN_MENU':
			return {
				...state,
				isDropDownMenu: action.payload
			}
		default:
			return state
	}
}